import { useMemo } from 'react';
import cards from '~/assets/icons/cards.svg';
import cash from '~/assets/icons/cash.svg';
import chest from '~/assets/icons/chest.svg';
import keyIcon from '~/assets/icons/key.svg';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { ShopPreview } from '~/components/ui/ShopPreview';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { WalletType } from '~/shared';
import { useLayoutSelector } from '../../redux/hooks';
import {
	StyledButtonContent,
	StyledOnlyCaseContainer,
	StyledOnlyCaseTopContainer,
} from './AcquireInfoSelection.styled';
interface IAcquireInfoSelection extends React.HTMLAttributes<HTMLDivElement> {
	onActionButtonClick: (actionName: string, walletType?: WalletType) => void;
}

const AcquireInfoSelection = ({
	onActionButtonClick,
}: IAcquireInfoSelection) => {
	const selectedIndex = useLayoutSelector(
		(state) => state.vehicleSelection.selectedIndex,
	);
	const shopVehicles =
		useObservable(rage.vehicleShop.getShopInfo())?.vehicles || [];

	const currentVehicle = useMemo(
		() => shopVehicles[selectedIndex],
		[shopVehicles, selectedIndex],
	);

	const shopPreview = useMemo(() => {
		if (shopVehicles.length > 0) {
			return {
				visible: true,
				name: rage.vehicles.getVehicleNameByModel(currentVehicle.model) || '',
				price: currentVehicle.priceCash,
				hide: {
					price: currentVehicle?.tags?.onlyCase,
					buttons: currentVehicle?.tags?.onlyCase,
				},
				customButtons: [
					{
						color: ButtonColors.Default,
						text: 'Картой',
						icon: cards,
						onClick: () => onActionButtonClick('buy', WalletType.Bank),
					},
					{
						color: ButtonColors.Buy,
						text: 'Наличными',
						icon: cash,
						onClick: () => onActionButtonClick('buy', WalletType.Cash),
					},
					{
						color: ButtonColors.Default,
						text: 'Тест-драйв',
						icon: keyIcon,
						onClick: () => onActionButtonClick('test-drive'),
					},
				],
			};
		}

		return {
			visible: false,
			name: '',
			price: 0,
		};
	}, [shopVehicles, selectedIndex, currentVehicle, onActionButtonClick]);

	return (
		<ShopPreview {...shopPreview} style={{ top: 145, right: 60 }}>
			{currentVehicle?.tags?.onlyCase && (
				<StyledOnlyCaseContainer>
					<StyledOnlyCaseTopContainer>
						<Text style={{ opacity: 0.5 }}>Доступно в</Text>
						<Text style={{ fontWeight: 700, textAlign: 'right' }}>
							Кейс “{currentVehicle?.caseName}”
						</Text>
						<img src={chest} />
					</StyledOnlyCaseTopContainer>
					<Button color={ButtonColors.Select2} height={ButtonHeight.Height40}>
						<StyledButtonContent>
							<img width={16} height={16} src={chest} />
							<Text>Открыть содержимое кейса</Text>
						</StyledButtonContent>
					</Button>
				</StyledOnlyCaseContainer>
			)}
		</ShopPreview>
	);
};

export { AcquireInfoSelection };
